/** Indian GSTIN: 15 chars — state(2) + PAN(10) + entity(1) + Z + checksum(1) */
const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/i;

const isZeroOnlyValue = (value) => {
  const digitsOnly = String(value).replace(/\D/g, "");
  return !digitsOnly || /^0+$/.test(digitsOnly);
};

export const formatGstNo = (gst) => {
  if (gst == null || gst === "") return "NA";

  const normalized = String(gst).trim();
  if (!normalized || normalized === "N/A") return "NA";
  if (/^nil$/i.test(normalized)) return "NA";
  if (/^n\/?a$/i.test(normalized)) return "NA";
  if (isZeroOnlyValue(normalized)) return "NA";

  const gstin = normalized.replace(/\s+/g, "").toUpperCase();
  if (!GSTIN_REGEX.test(gstin)) return "NA";

  return gstin;
};
